export const startup1 = {
    instagram: 'https://www.instagram.com/let.her.travel/',
    facebook: 'https://www.facebook.com/LetHerTravell/',
    headline: 'Let Her Travel',
    description:
      'Let Her Travel is a beautiful initiative taken by young entrepreneurs in order to facilitate travel among women. It is the first women centered organization which plans, customizes and organizes trips only for women. Let her travel was formed in 2019 with a vision to redefine boundaries for women and evolutionize the way female travelling is perceived in the developing country. It is driven by a mission to spread happiness and turn all the travelling fantasies of women come true. It inspires women to wander the world without limitations and makes travel safer for them. It has conducted many trips for women across the nation, has capacitated over 200 women rovers to spread their wings and fly-high and continues to do so with same zeal and ardour. E-Cell has been a proud supporter of Let her travel, working firmly towards their belief of helping budding entrepreneur go through the journey of converting ideas into reality.',
    img: require('../assets/images/startups/winner_logo1.jpeg'),
    alt: 'lethertravelLogo',
    start: 'row'
  };

  export const startup2 = {
    instagram: 'https://www.instagram.com/egniter.in/?hl=en',
    facebook: 'https://www.facebook.com/egniter.in/',
    headline: 'Egniter',
    description:
      'Egniter has carved a niche for itself in the Event Management, Marketing and Designing circuits in central India. It has become a celebrated name amongst the aspirants of management related activities. It holistically promotes excellence, Intellectual discipline, and professional leadership. Egniter is a Start-up formed in 2019 with the motive to help businesses emerge and connect to the creative world, building the perfect avenue for one’s brand to lead. At Egniter, while excellence and professionalism are meant to be uncompromising, it is believed that the significance of entrepreneurial skill is indelible to an integrated experience in various communities. E-Cell has been a strong part of Egniter’s journey into reality. The founder of Egniter is currently the president of E-Cell and is helping further in shaping fledging minds to become future inventorial entrepreneurs.',
    img: require('../assets/images/startups/Screenshot_2021_0110_153031.jpg'),
    alt: 'EgniterLogo',
    start: 'row-reverse'
  };

  export const associate1 = {
    instagram: 'https://www.instagram.com/wadhwanifoundation/',
    facebook: 'https://www.facebook.com/wadhwanifoundation',
    headline: 'Wadhwani Foundation',
    description:
      "Wadhwani Foundation's flagship Initiative, National Entrepreneurship Network (NEN) has initiated a concerted effort to transform Indore and Bhopal regions into a model entrepreneurship ecosystem. The initiative is aimed at creating impact opportunities in emerging cities with entrepreneurship development as a key tool for sustainable job creation.",
    img: require('../assets/images/associates/WF-Logo-White.png'),
    alt: 'WadhwaniFoundationLogo',
    start: 'row'
  };

  export const associate2 = {
    instagram: 'https://www.instagram.com/headstartindia/',
    facebook: 'https://www.facebook.com/groups/headstarters/',
    headline: 'HeadStart',
    description:
      'Head-start organized a workshop in E-summit, the event hosted by E-cell which focussed on guiding participants about "How to find tools that align with your needs." It helped students to identify and keep an eye on some cutting-edge technologies which might reinvent the future for them',
    img: require('../assets/images/associates/headstart_logo.png'),
    alt: 'EgniterLogo',
    start: 'row-reverse'
  };

  export const associate3 = {
    instagram: 'https://www.instagram.com/engineerbabuinc/?hl=en',
    facebook: 'https://www.facebook.com/engineerbabuofficial/',
    headline: 'Engineer Babu',
    description:
      'Engineer Babu conducted an insightful session which can help budding entrepreneurs who often struggle with product differentiation to identify the features that will make their product unique and attract the early adopters. It also aimed at guiding participants about how to successfully implement their innovative ideas.',
    img: require('../assets/images/associates/Ebabu-Final-Logo.png'),
    alt: 'EngineerBabuLogo',
    start: 'row'
  };

  export const associate4 = {
    instagram: 'https://www.instagram.com/digital_gurukul/',
    facebook: 'https://www.facebook.com/OurDigitalGurukul',
    headline: 'Digital Gurukul',
    description:
      "E-Cell in collaboration with Digital Gurukul organized a workshop on Digital Marketing. This workshop aimed at highlighting that the woeld is now turning into digital and how one has to adopt this change to dominate the digital era. Many tips and tricks to hack the figital world were also ahared in the workshop.",
    img: require('../assets/images/associates/Digital_Gurukul_Logo-2.png'),
    alt: 'DigitalGurukulLogo',
    start: 'row-reverse'
  };

  export const associate5 = {
    instagram: 'https://www.instagram.com/eshipsimplified/',
    facebook: 'https://www.facebook.com/eshipSimplified/',
    headline: 'E-Ship Simplified',
    description:
      'E-Cell in collaboration with eship simplified organized a workshop on Idea Validation, which focused on the principles of how to convert your innovative ideas into successfully business models.The workshop gave the attendees the confidence to build a roadmap to their success.',
    img: require('../assets/images/associates/Eship-Simplyfied.png'),
    alt: 'E-ShipSimplifiedLogo',
    start: 'row'
  };
